export default __webpack_public_path__ + "static/media/ic_30_back.08d05cc8.svg";